import { Flex, Radio } from "antd";
import androidSvg from "../../../../assets/android.svg";
import iosSvg from "../../../../assets/ios.svg";

const NotificationPreview = ({ platform, setPlatform, formData }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "24px",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          border: "1px solid #E4E6EF",
          borderRadius: "12px",
          paddingTop: "20px",
          maxHeight: "260px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <div className="flex flex-col items-center gap-6">
          {/* Phone preview */}
          <div
            className={`relative ${
              platform === "ios" ? "w-[230px]" : "w-[275px]"
            }`}
          >
            {/* SVG background */}
            <img
              src={platform === "ios" ? iosSvg : androidSvg}
              alt="phone"
              className="w-full"
            />

            {/* Notification card */}
            <div
              className="absolute top-[60px] left-[22px] right-[22px]  "
              style={{
                background:
                  platform === "ios" ? "rgba(255, 255, 255, 0.55)" : "#fff",
                display: "flex",
                flexDirection: "column",
                borderRadius: platform === "ios" ? "6px" : "10px",
              }}
            >
              <div style={{ padding: platform === "ios" ? "6px" : "10px" }}>
                <div className="flex justify-between text-xs text-gray-700 mb-1">
                  <span
                    className="flex items-center gap-1"
                    style={{ fontSize: platform === "ios" ? "6px" : "8px" }}
                  >
                    <span
                      className="w-3 h-3 rounded-sm"
                      style={{ backgroundColor: "#000" }}
                    />
                    Application name
                  </span>
                  <span
                    style={{ fontSize: platform === "ios" ? "6px" : "8px" }}
                  >
                    30m ago
                  </span>
                </div>

                {/* <Flex vertical> */}
                <div className="flex-1">
                  <p
                    className="text-black leading-tight"
                    style={{ fontSize: platform === "ios" ? "6px" : "10px" }}
                  >
                    {formData?.title || "Your title will display here"}
                  </p>
                  <p
                    style={{
                      fontSize: platform === "ios" ? "6px" : "10px",
                      color: "#686868",
                    }}
                  >
                    {formData?.message || "Your description will display here"}
                  </p>
                </div>
              </div>

              {formData?.notificationImageType == 1 &&
                formData?.notificationImagePreview && (
                  <img
                    src={formData?.notificationImagePreview}
                    alt="preview"
                    className="w-full object-cover"
                    style={{
                      height: "100px",
                      width: "100%",
                      borderRadius:
                        platform === "ios" ? "0 0 6px 6px" : "0 0 16px 16px",
                    }}
                  />
                )}
              {/* </Flex> */}
            </div>
          </div>

          {/* Platform toggle */}
        </div>
      </div>
      <Radio.Group
        value={platform}
        onChange={(e) => setPlatform(e.target.value)}
        className="flex gap-10"
      >
        <Radio value="android">Android</Radio>
        <Radio value="ios">iOS</Radio>
      </Radio.Group>
    </div>
  );
};

export default NotificationPreview;
